var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPageOnBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_897",
    "data-name": "Raggruppa 897",
    transform: "translate(298 -919)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Componente_68_1",
    "data-name": "Componente 68 \\u2013 1",
    transform: "translate(-298 919)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_896",
    "data-name": "Raggruppa 896",
    transform: "translate(-388 951) rotate(-180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Componente_67_3",
    "data-name": "Componente 67 \\u2013 3",
    transform: "translate(-420 919)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_427",
    "data-name": "Rettangolo 427",
    width: 32,
    height: 32,
    rx: 4,
    fill: "#702180"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1514",
    "data-name": "Tracciato 1514",
    d: "M290.313,69.646a.5.5,0,0,1,.707,0l4,4a.5.5,0,0,1,0,.707l-4,4a.5.5,0,0,1-.707-.707L293.96,74l-3.647-3.646A.5.5,0,0,1,290.313,69.646Z",
    transform: "translate(-276 -57)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1515",
    "data-name": "Tracciato 1515",
    d: "M290.266,69.6a.566.566,0,0,1,.8,0l4,4a.565.565,0,0,1,0,.8l-4,4a.567.567,0,0,1-.8-.8l3.6-3.6-3.6-3.6A.567.567,0,0,1,290.266,69.6Z",
    transform: "translate(-276 -57)",
    fill: "#fff",
    fillRule: "evenodd"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageOnBack);
export default __webpack_public_path__ + "static/media/page-on-back.a662dae6e8bb75f95bb584590c10acd3.svg";
export { ForwardRef as ReactComponent };